import { CellColors } from '../model/colors.model';
import { HighMedLowRating } from '../model/user';
import { VrmRating, VrmRatingClasses, VrmRatingScore } from '../model/driver.model';

enum CompanyRiskLevelRatings {
  high = 'high',
  medium = 'medium',
  low = 'low',
  safeDriver = 'safeDriver',
  notApplicable = 'n/a',
}

export function compareVrmRatingToColleagues(
  driverIndexValue: number,
  driverIndexScore: number,
  standardDeviation: number,
  average: number
): number {
  const mark1 = average + standardDeviation;
  const mark2 = average + 2 * standardDeviation;

  if (driverIndexValue === mark1 && driverIndexValue === mark2) {
    return driverIndexScore;
  }

  if (driverIndexValue <= mark1) {
    return 1;
  }

  if (driverIndexValue >= mark2) {
    return 3;
  }

  return 2;
}

export function getAgGridTextClassForScore(score: number): string | null {
  switch (score) {
    case VrmRatingScore.lowRisk:
      return VrmRatingClasses.lowRisk;
    case VrmRatingScore.mediumRisk:
      return VrmRatingClasses.mediumRisk;
    case VrmRatingScore.highRisk:
      return VrmRatingClasses.highRisk;
    case VrmRatingScore.veryHighRisk:
      return VrmRatingClasses.veryHighRisk;
    default:
      return null;
  }
}

export function convertRatingScoreToRatingText(ratingScore: number): string {
  switch (ratingScore) {
    case VrmRatingScore.lowRisk:
      return VrmRating.lowRisk;
    case VrmRatingScore.mediumRisk:
      return VrmRating.mediumRisk;
    case VrmRatingScore.highRisk:
      return VrmRating.highRisk;
    case VrmRatingScore.veryHighRisk:
      return VrmRating.veryHighRisk;
    default:
      return 'N/A';
  }
}

export function sortHighMediumLowRatings(ratingA: string, ratingB: string): number {
  const ratings = {
    high: 3,
    medium: 2,
    low: 1,
  };
  const ratingAValue = ratings[ratingA.toLowerCase()] ?? null;
  const ratingBValue = ratings[ratingB.toLowerCase()] ?? null;

  return ratingAValue > ratingBValue ? 1 : -1;
}

export const convertCompanyPointsScoreToRating = (score: number, riskLevelBoundaries: HighMedLowRating): string => {
  switch (true) {
    case score >= riskLevelBoundaries.high:
      return CompanyRiskLevelRatings.high;
    case score >= riskLevelBoundaries.medium:
      return CompanyRiskLevelRatings.medium;
    case score >= riskLevelBoundaries.low:
      return CompanyRiskLevelRatings.low;
    default:
      return CompanyRiskLevelRatings.safeDriver;
  }
};

export const companyPointsCssClass = (score: number, riskLevelBoundaries: HighMedLowRating): string => {
  switch (true) {
    case score >= riskLevelBoundaries.high:
      return CellColors.red;
    case score >= riskLevelBoundaries.medium:
      return CellColors.amber;
    case score >= riskLevelBoundaries.low:
      return CellColors.green;
    default:
      return CellColors.blue;
  }
};
